import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'app/shared/api/microservices';

const baseUrl = `${process.env.DATA_MANAGER_URL || 'http://localhost'}${process.env.DATA_MANAGER_PORT && process.env.DATA_MANAGER_PORT !== '' ? `:${process.env.DATA_MANAGER_PORT}` : ''}`;
const staggeredBaseQuery = axiosBaseQuery({ baseUrl: baseUrl });

// Full data-manager origin (URL + port). Use this — not the bare DATA_MANAGER_URL
// global — to resolve server-relative assets like source-type icons (/static/...):
// in dev DATA_MANAGER_URL has no port, so only the composed form reaches the API.
export const DATA_MANAGER_BASE_URL = baseUrl;

export const dataManagerServiceApi = createApi({
  reducerPath: 'dataManagerApi',
  baseQuery: staggeredBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'ALL_SOURCES',
    'ALL_DOCUMENTS',
    'ALL_COLLECTIONS',
    'COLLECTION',
    'ALL_PIPELINES',
    'PIPELINE',
    'ALL_NEWSLETTERS',
    'VALIDATE_BLOCK',
    'ALL_DATASOURCES',
    'DATASOURCE',
    'ALL_CHAT_PROFILES',
    'CHAT_PROFILE',
  ],
});
